module.exports = __webpack_public_path__ + "static/media/SF_nn_sentrert_logo_oslo_viken_pos.e1a05471.png";